/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-investigation.reducer';

export const PatientProcedureInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureInvestigationEntity = useAppSelector(state => state.patientProcedureInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.detail.title">PatientProcedureInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureInvestigationEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.labPres">Lab Pres</Translate>
          </dt>
          <dd>{patientProcedureInvestigationEntity.labPres ? patientProcedureInvestigationEntity.labPres.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureInvestigation.order">Order</Translate>
          </dt>
          <dd>{patientProcedureInvestigationEntity.order ? patientProcedureInvestigationEntity.order.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-investigation/${patientProcedureInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureInvestigationDetail;
